<div mat-dialog-content>
    <div class="row">
        <input placeholder="Enter Url" type="text" [(ngModel)]="videoURL" style="width:275px;" />
        <span class="ml-2">
            <button class="btn btn-default" (click)="onSelect()">Ok</button>
        </span>
    </div>
</div>